// PGCET MCA Mock 7 — Analytical Ability & Logical Reasoning (questions 56–70)
const pgcetmcaAnalyticalReasoning = [
  {
    id: 56,
    question: "If each letter is replaced by its position in the English alphabet and CAT is coded as 24, then DOG is coded as",
    options: ["A. 24", "B. 26", "C. 27", "D. 25"],
    answer: "B"
  },
  {
    id: 57,
    question: "In a certain code language, FRIEND is written as HUMJTK. How is CANDLE written in that code?",
    options: ["A. EDRIRL", "B. EDRJRL", "C. DCQHQK", "D. EDQIRL"],
    answer: "A"
  },
  {
    id: 58,
    question: "In a certain code language, SYSTEM is written as METSYS. How is NETWORK written in that code?",
    options: ["A. KRWOTEN", "B. NROWTEK", "C. KROWTEN", "D. KROWETN"],
    answer: "C"
  },
  {
    id: 59,
    question: "P is the father of Q. Q is the sister of R. S is the wife of R. T is the son of R and S. How is P related to T?",
    options: ["A. Father", "B. Uncle", "C. Grandfather", "D. Father-in-law"],
    answer: "C"
  },
  {
    id: 60,
    question: "Introducing a man, Neha said, \"He is the only son of my mother's father.\" How is the man related to Neha?",
    options: ["A. Father", "B. Brother", "C. Cousin", "D. Maternal uncle"],
    answer: "D"
  },
  {
    id: 61,
    question: "M is the brother of N. N is the daughter of O. O is the wife of P. How is M related to P?",
    options: ["A. Son", "B. Brother", "C. Nephew", "D. Father"],
    answer: "A"
  },
  {
    id: 62,
    question: "A man is facing North. He turns 90° clockwise, then 180° anticlockwise, and then 45° clockwise. Which direction is he facing now?",
    options: ["A. North-East", "B. North-West", "C. South-West", "D. South-East"],
    answer: "B"
  },
  {
    id: 63,
    question: "Rita walks 12 m towards South, turns left and walks 5 m. How far and in which direction is she from her starting point?",
    options: ["A. 13 m, South-West", "B. 17 m, South-East", "C. 13 m, South-East", "D. 7 m, East"],
    answer: "C"
  },
  {
    id: 64,
    question: "One morning after sunrise, Arun was standing facing a pole. The shadow of the pole fell exactly to his right. Which direction was he facing?",
    options: ["A. North", "B. East", "C. West", "D. South"],
    answer: "D"
  },
  {
    id: 65,
    question: "What is the angle between the hour hand and the minute hand of a clock at 7:20?",
    options: ["A. 100°", "B. 110°", "C. 90°", "D. 120°"],
    answer: "A"
  },
  {
    id: 66,
    question: "How many times do the hour hand and the minute hand of a clock coincide in a day (24 hours)?",
    options: ["A. 24", "B. 22", "C. 44", "D. 48"],
    answer: "B"
  },
  {
    id: 67,
    question: "If 1 January 2026 is a Thursday, what day of the week is 1 March 2026?",
    options: ["A. Saturday", "B. Monday", "C. Sunday", "D. Friday"],
    answer: "C"
  },
  {
    id: 68,
    question: "How many odd days are there in a leap year?",
    options: ["A. 1", "B. 0", "C. 3", "D. 2"],
    answer: "D"
  },
  {
    id: 69,
    question: "Ornithology : Birds :: Entomology : ?",
    options: ["A. Insects", "B. Words", "C. Fossils", "D. Fungi"],
    answer: "A"
  },
  {
    id: 70,
    question: "ACE : FHJ :: BDF : ?",
    options: ["A. HJL", "B. GIK", "C. GHI", "D. FIK"],
    answer: "B"
  }
];

export default pgcetmcaAnalyticalReasoning;
